"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(theme) {
  return {
    Menu: {
      overflowY: 'auto',
      maxHeight: 250,
      '& li:nth-child(odd)': {
        backgroundColor: theme['$input-background']
      },
      '&.horizontal-regular': {
        minWidth: 180
      },
      '&.horizontal-large': {
        minWidth: 300
      }
    },
    tetherElement: {
      zIndex: theme['$z-index-dropdown']
    },
    MenuItem: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      '& p': {
        margin: 0
      },
      '& .insert-label': {
        fontWeight: 500,
        color: 'rgb(54, 142, 248)',
        cursor: 'pointer'
      }
    }
  };
};

exports["default"] = _default;
//# sourceMappingURL=style.js.map